import { computed } from "vue";

import { DictionariesHelper } from "@/helpers";
import { useDictionariesStore } from "@/stores";

export function useCustomCompanySetup() {
  const dictionariesStore = useDictionariesStore();

  /**
   * Only Nordea Terms and Danske Bank have these features at the moment. As that is unlikely to change, we have this simple check.
   * In the future, we may want to consider moving this to a the backend as part of a larger system for special features.
   */
  const hasSuggestTerms = computed<boolean>(() => suggestTermDictionaryId.value !== null);

  const suggestTermDictionaryId = computed<string | null>(
    () =>
      dictionariesStore.companyDictionaries.find(
        (d) =>
          d.id === DictionariesHelper.NORDEA_TERMS_DICTIONARY_ID ||
          d.id === DictionariesHelper.DANSKE_BANK_TERMS_DICTIONARY_ID
      )?.id ?? null
  );

  return {
    isCompactArticlesExpandedByDefault: hasSuggestTerms,
    showSuggestTerms: hasSuggestTerms,
    suggestTermDictionaryId
  };
}
